export default "__VITE_ASSET__B5uiuUv6__"